import { service } from '@ember/service';
import Controller from '@ember/controller';
import type DepartmentModel from 'scaleflow/models/department';
import type StoreService from 'scaleflow/services/store';
import type BetaToggleService from 'scaleflow/services/beta-toggle';
export default class DepartmentsDepartmentHomeController extends Controller {
  @service('store') declare store: StoreService;
  @service declare betaToggle: BetaToggleService;
  declare model: DepartmentModel;

  get recentInitiatives() {
    const initiatives = new Map();
    this.model.teams.forEach((team: any) => {
      team.recentInitiatives.forEach((initiative: any) => {
        if (!initiatives.has(initiative.id)) {
          initiatives.set(initiative.id, initiative);
        }
      });
    });
    return Array.from(initiatives.values());
  }

  get departmentMetrics() {
    const goals: any[] =
      (this.model as any).combinedGoalsFromTeamsInitiativesAndDepartment ?? [];
    const seen = new Set<string>();
    const metrics: any[] = [];
    goals.forEach((goal: any) => {
      const targets = goal.targets?.content ?? [];
      targets.forEach((target: any) => {
        const metric = target.metric?.content;
        if (metric?.id && !seen.has((metric.id as string) ?? '')) {
          seen.add((metric.id as string) ?? '');
          metrics.push(metric);
        }
      });
    });
    return metrics;
  }
}
